'use client';

import type { FC, HTMLAttributes } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Box } from '@eqi-investimentos/react';
export const ContainerComponent: FC<Omit<ThumbProps, 'href' | 'target'>> = ({
  alt,
  colorProgress,
  erroPlaceholder,
  fit = 'cover',
  height = 40,
  progress,
  radius = 0,
  src,
  width = 40
}) => {
  return <Box position="relative" w={`${width}px`} h={`${height}px`} borderRadius={`${radius}px`} overflow="hidden" transition="all 300ms ease-in-out" data-sentry-element="Box" data-sentry-component="ContainerComponent" data-sentry-source-file="index.tsx">
      <Image src={src || '/assets/placeholder_assets.png'} fill alt={alt ?? ''} blurDataURL={src ?? undefined} quality={100} unoptimized loading="eager" onError={({
      currentTarget
    }) => {
      currentTarget.onerror = null; // prevents looping
      currentTarget.src = erroPlaceholder || '/assets/placeholder_assets.png';
    }} style={{
      overflowClipMargin: 'unset',
      overflow: 'visible',
      objectFit: fit
    }} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      {!!progress && <Box position="absolute" bottom={0} w="full" h="0.7rem">
          <Box data-testid="thumb-progress" w={`${progress}%`} h="0.7rem" transition="all 500ms ease-in-out" bgColor={colorProgress?.replace('bg-[', '').replace(']', '')} borderRadius={`${radius}px`}>
            .
          </Box>
        </Box>}
    </Box>;
};
const WithLink = ({
  href,
  target = '_self',
  ...props
}: ThumbProps) => <Link href={href!} target={target} passHref prefetch data-sentry-element="Link" data-sentry-component="WithLink" data-sentry-source-file="index.tsx">
    <ContainerComponent {...props} data-sentry-element="ContainerComponent" data-sentry-source-file="index.tsx" />
  </Link>;
export const Thumb = ({
  href,
  ...props
}: ThumbProps) => href ? <WithLink href={href} {...props} /> : <ContainerComponent {...props} />;
export type ThumbProps = HTMLAttributes<HTMLDivElement> & {
  alt?: string;
  colorProgress?: `bg-[var(${string})]`;
  erroPlaceholder?: string;
  fit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  full?: boolean;
  height?: number;
  href?: string;
  progress?: number;
  radius?: number;
  src?: string | null;
  target?: string;
  width?: number;
};